import { Injectable } from '@angular/core';
import { CmxHttpClient } from '@cemex/cmx-client-layout';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';
import { CxApiMetadataService, CxApiMetadataStrategy } from '../cx-api-metadata/cx-api-metadata.service';
import { CxApiMetadataEntity } from '../cx-api-metadata/store/reducers/cx-api-metadata.reducer';
import { CxExperienceEntity, CxExperienceState } from '../cx-experiences/store/reducers/cx-experience.reducer';
import { CxCustomerExperienceResponse } from './models/customer-experiences';
import CxCustomerActions from './store/actions/cx-customer.actions';
import * as cxExperienceSelector from '../cx-experiences/store/selectors/cx-experiences.selector';
import { ORDER_EXPERIENCES } from '../../constants/order-experiences';

@Injectable()
export class CxCustomerService {
  constructor(
    private store: Store<CxExperienceState>,
    private cxApiMetadata: CxApiMetadataService,
    private http: CmxHttpClient,
  ) {}

  public selectCustomerExperiences$(customerId: number, strategy?: CxApiMetadataStrategy) {
    return this.cxApiMetadata
      .connectMetadata$(CxCustomerActions.fetchCustomerExperiences({ customerId }), strategy)
      .pipe(
        switchMap((metadata) =>
          this.store.select(cxExperienceSelector.selectCxExperiencesById(), { ids: metadata.entityIds }).pipe(
            filter((res) => res.length === metadata.entityIds.length),
            map((res) => [res, metadata] as [CxExperienceEntity[], CxApiMetadataEntity]),
          ),
        ),
      );
  }

  // @TODO Consider to move to Cemex API library
  public fetchCustomerExperiences({
    customerId,
    productType,
    experience,
  }: {
    customerId: number;
    productType?: string;
    experience?: ORDER_EXPERIENCES;
  }) {
    const params = {
      customerId: `${customerId}`,
    };
    if (!!productType && !!experience) {
      params['productTypeCodes'] = productType;
      params['experienceCodes'] = experience;
    }
    return this.http.get<CxCustomerExperienceResponse>(`/v2/cgm/orders/experiences`, {
      params,
    });
  }
}
